var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from "path-shared/models/filter-data";
var MaquinaIncidenciaFilter = /** @class */ (function (_super) {
    __extends(MaquinaIncidenciaFilter, _super);
    function MaquinaIncidenciaFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.somId = null;
        _this.codiMaquina = '';
        _this.dataCreacioInici = null;
        _this.dataCreacioFi = null;
        _this.dataResolucioInici = null;
        _this.dataResolucioFi = null;
        _this.labels['codiMaquina'] = _this.i18n('Codi màquina');
        _this.labels['somId'] = _this.i18n('Codi');
        _this.labels['dataCreacioInici'] = _this.i18n('Inici data creació');
        _this.labels['dataCreacioFi'] = _this.i18n('Fi data creació');
        _this.labels['dataResolucioInici'] = _this.i18n('Inici data resolució');
        _this.labels['dataResolucioFi'] = _this.i18n('Fi data resolució');
        return _this;
    }
    return MaquinaIncidenciaFilter;
}(FilterData));
export { MaquinaIncidenciaFilter };
